import { logout } from '../slices/authSlice';

const TOKEN_KEY = 'token';

const MEMBER_ACCESS_DENIED_CODES = new Set([
  'USER_NOT_PROVISIONED',
  'NOT_ON_ALLOWLIST',
  'MEMBER_INACTIVE',
  'MEMBER_OFF_ROSTER',
]);

export function getStoredMemberToken(reduxToken) {
  if (reduxToken) return reduxToken;
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function memberAccessDeniedMessage(data) {
  if (data?.code === 'MEMBER_INACTIVE') {
    return 'Your account is inactive. Contact your HR admin.';
  }
  if (data?.code === 'MEMBER_OFF_ROSTER') {
    return 'Your employer access has ended. Contact your HR admin.';
  }
  if (data?.code === 'ROSTER_UNAVAILABLE') {
    return 'Unable to verify your employer access right now. Please try again.';
  }
  if (data?.code === 'USER_NOT_PROVISIONED' || data?.code === 'NOT_ON_ALLOWLIST') {
    return 'Account not set up. Contact your HR admin.';
  }
  return data?.error || 'Your session has ended. Please sign in again.';
}

/**
 * Handle failed member dashboard/session responses.
 * @returns {'handled'|'retry'} handled = navigated away; retry = show inline error
 */
export function handleMemberSessionFailure({ status, data = {}, dispatch, navigate }) {
  const code = data?.code;

  if (
    status === 401 ||
    status === 403 ||
    (code && MEMBER_ACCESS_DENIED_CODES.has(code))
  ) {
    const loginMessage =
      status === 403 || MEMBER_ACCESS_DENIED_CODES.has(code)
        ? memberAccessDeniedMessage(data)
        : 'Your session has expired. Please sign in again.';
    dispatch(logout());
    navigate('/login', { replace: true, state: { loginMessage } });
    return 'handled';
  }

  if (status === 404) {
    dispatch(logout());
    navigate('/login', {
      replace: true,
      state: { loginMessage: 'Account not found. Please sign in again.' },
    });
    return 'handled';
  }

  if (status === 503) {
    return 'retry';
  }

  return 'retry';
}
